import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthShell } from '@/components/auth/auth-shell';
import { LoginForm } from '@/components/auth/login-form';
import { LoginHero } from '@/components/auth/login-hero';
import { useAuth } from '@/contexts/AuthContext';
import { getRoleHomeRoute } from '@/lib/role-redirect';

export function LoginPage() {
  const { isAuthenticated, user, isLoading } = useAuth();
  const navigate = useNavigate();

  // If already authenticated, redirect to the user's dashboard after the
  // current render commits.  Using useEffect (not <Navigate> / useLayoutEffect)
  // ensures only ONE navigation fires per auth-state transition, preventing the
  // repeated navigate() calls that <Navigate>'s internal useLayoutEffect causes
  // when the component re-renders due to React Query background refetches.
  useEffect(() => {
    if (!isLoading && isAuthenticated && user) {
      void navigate(getRoleHomeRoute(user), { replace: true });
    }
  }, [isLoading, isAuthenticated, user, navigate]);

  // Don't flash the login form while the redirect is in flight.
  if (!isLoading && isAuthenticated) {
    return null;
  }

  return (
    <AuthShell
      hero={<LoginHero />}
      title="Welcome back"
      description="Sign in to your Secure Labs account"
      footer={
        <p className="text-center text-xs text-[var(--text-tertiary)]">
          By signing in you agree to our{' '}
          <a href="/terms" className="underline underline-offset-4 hover:text-[var(--text-accent)]">
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            href="/privacy"
            className="underline underline-offset-4 hover:text-[var(--text-accent)]"
          >
            Privacy Policy
          </a>
          .
        </p>
      }
    >
      <LoginForm />
    </AuthShell>
  );
}
